import React, { FC } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

interface Props {
  color?: 'primary' | 'secondary' | 'inherit';
  show: boolean | undefined;
}

const ButtonLoader: FC<Props> = ({ show, color }) => (
  <>
    {show && (
      <CircularProgress
        color={color || 'primary'}
        size={34}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          marginTop: -17,
          marginLeft: -17
        }}
      />
    )}
  </>
);

export { ButtonLoader };
